<template>
  <div>
    <van-nav-bar @click-left="ReturnPage()" left-arrow>
      <template #left>
        <van-icon name="arrow-left" color="#000" size="22" />
      </template>
      <template #title>
        <p style="font-size: 13pt">
          {{ PreviewsModel.Collection.Name }}
        </p>
      </template>
    </van-nav-bar>

    <van-image
      lazy-load
      class="item_picture"
      fit="contain"
      :src="PreviewsModel.Collection.CompleteImages"
    />

    <div
      style="
        background-color: #fff;
        border-radius: 5px;
        width: calc(100% - 15px);
        margin: 0 auto;
        margin-top: 10px;
        padding: 5px;
      "
    >
      <div
        style="
          height: 40px;
          border-bottom: 1px solid #e6e6e6;
          line-height: 40px;
          font-size: 18px;
        "
      >
        {{ tools.GetLanguageValue("public.app.套餐内最大可选") }}
      </div>
      <div style="width: 100%">
        <div
          style="
            display: flex;
            height: 45px;
            align-items: center;
            gap: 15px;
            margin-top: 15px;
          "
        >
          <van-badge :content="PreviewsModel.Collection.Drinks">
            <div class="child">
              {{   tools.GetLanguageValue("public.app.饮料")  }}
            </div>
          </van-badge>
          <van-badge :content="PreviewsModel.Collection.Foodstuff">
            <div class="child">       {{   tools.GetLanguageValue("public.app.食品")  }}</div>
          </van-badge>
          <van-badge :content="PreviewsModel.Collection.Sweetmeats">
            <div class="child">       {{   tools.GetLanguageValue("public.app.甜品")  }}</div>
          </van-badge>
          <van-badge :content="PreviewsModel.Collection.Rest">
            <div class="child">       {{   tools.GetLanguageValue("public.app.其他")  }}</div>
          </van-badge>
        </div>

        <div v-for="(item, index) in CollectionUsable" :key="index">
          <div
            style="
              width: calc(100% - 30px);
              margin: 0 auto;
              display: flex;
              gap: 8px;
              justify-content: space-between;
              border-radius: 8px;
              margin: 5px;
              padding: 5px 10px;
              background-color: #ff3333;
              color: #fff;
            "
            v-if="index < 10 || ShowInfo"
          >
            <div>{{ item.Title }}</div>
            <div>{{ item.Qty }}</div>
          </div>
        </div>
      </div>

      <!-- <div style="height: 40px; text-align: center">
        <van-icon
          size="40"
          v-if="ShowInfo"
          @click="ShowInfo = !ShowInfo"
          name="arrow-up"
        />
        <van-icon
          size="40"
          v-if="!ShowInfo"
          @click="ShowInfo = !ShowInfo"
          name="arrow-down"
        />
      </div> -->
    </div>

    <div
      style="
        background-color: #fff;
        border-radius: 5px;
        width: calc(100% - 15px);
        margin: 0 auto;
        margin-top: 10px;
        padding: 5px;
      "
    >
      <div
        style="
          height: 40px;
          border-bottom: 1px solid #e6e6e6;
          line-height: 40px;
          font-size: 18px;
        "
      >
        {{ tools.GetLanguageValue("public.app.简介") }}
      </div>
      <div
        v-html="PreviewsModel.Collection.Description"
        style="margin: 15px 4px"
      ></div>
    </div>

    <!-- 分类列表 -->
    <div>
      <van-tabs
        v-model:active="active"
        color="#3ca7f0"
        @change="beforeChange"
        scrollspy
        sticky
      >
        <van-tab
          v-for="(item, index) in PreviewsModel.Categorys"
          :key="index"
          :title="item.Name"
        >
          <!-- 商品列表 -->
          <p>{{ item.Name }}</p>
          <div style="height: 600px" v-if="item.Products.length == 0">
            <van-empty
              :description="tools.GetLanguageValue('public.app.正在加载')"
            />
          </div>
          <div
            class="item_content"
            v-for="ProductItem in item.Products"
            :key="ProductItem.Id"
          >
            <div
              style="margin: 3px; display: flex"
              @click="StorePreviewDetail(ProductItem)"
            >
              <div style="width: 100%">
                <div
                  style="
                    height: 30px;
                    width: 100%;
                    border-bottom: 1px solid #e6e6e6;
                    line-height: 30px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div class="previewName">

                    {{ ProductItem.Name }}
                  </div>
                  <div style="color: red">
                      {{ ProductItem.PriceFormat }}
                    </div>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <van-image
                    lazy-load
                    style="width: 100px; margin: 5px; height: 80px"
                    fit="contain"
                    :src="ProductItem.CompleteImages"
                  />
                  <van-icon
                    name="eye-o"
                    color="#A6A6A6"
                    style="margin-right: 13px; size: 18pt"
                    size="20pt"
                  />

                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <br />
    <br />
  </div>
</template>
<script>
import axios from "../../commons/AxiosMethod.js"
import productBbroadwise from "../../components/tabbars/StoreProductBroadwise.vue"
import tabbar from "../../components/tabbars/storeTabbar.vue"
import LanguageSelect from "../../components/LanguageSelect.vue"
import tools from "../../commons/tools.js"
import { Collapse, CollapseItem, Tab, Tabs, showToast, NumberKeyboard } from "vant"

export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      ShowInfo: false,
      tools: tools,
      CollectionUsable: [], // 套餐可用信息
      PreviewsItems: [], // 预览弹窗
      CollectionId: "", // 当前分类
      PreviewsModel: {
        Collections: [],
        Collection: {},
        Categorys: [],
        Products: [],
        Category: {}
      },
      active: ""
    }
  },
  name: "App",
  mounted () {
    this.CollectionId = this.$route.query.collectionId

    this.GetPreviewCollectionSimple()
    this.GetPreviewCollectionUsable()
  },
  components: {
    productBbroadwise,
    tabbar,
    LanguageSelect
  },
  methods: {
    beforeChange (number, name) {
      if (this.PreviewsModel.Categorys.length < number + 1) {
        return
      }

      var category = this.PreviewsModel.Categorys[number]

      this.GetCategoryProduct(category)
      var category2 = this.PreviewsModel.Categorys[number + 1]
      this.GetCategoryProduct(category2)
    },
    GetCategoryProduct (category) {
      if (category.Products.length == 0) {
        axios.apiMethod(
          "/Store/StoreOrder/GetCategoryProduct?categoryId=" + category.Id,
          "get",
          {},
          (result) => {
            category.Products = result.Data
          }
        )
      }
    },

    ReturnPage () {
      history.back()
    },
    // 预览商品
    StorePreviewDetail (item) {
      this.$router.push({
        path: "storePreviewDetail",
        query: {
          productId: item.Id
        }
      })
    },
    // 查询预览数据
    GetPreviewCollectionSimple () {
      axios.apiMethod(
        "/Store/StoreOrder/GetPreviewCollectionSimple?collectionId=" +
          this.CollectionId,
        "get",
        {},
        (result) => {
          this.PreviewsModel = result.Data
          // this.PreviewsItems = result.Data;
        }
      )
    },
    // 套餐的介绍信息
    GetPreviewCollectionUsable () {
      axios.apiMethod(
        "/Store/StoreOrder/GetPreviewCollectionUsable?collectionId=" +
          this.CollectionId,
        "get",
        {},
        (result) => {
          this.CollectionUsable = result.Data
        }
      )
    },

    Skip (item) {
      var tableId = localStorage.getItem("Cache-TableId")
      this.$router.push({
        path: item,
        query: {
          tableId: tableId
        }
      })
    }
  }
}
</script>
    <style>
.shuoming p {
  padding: 0px !important;
  margin: 0px !important;
}
</style>
    <style lang="scss" scoped>
.item_price {
  width: 100px;
  line-height: 20px;
  color: #333;
  font-family: "Titillium Web", Arial, sans-serif;
  font-size: 18pt;
  margin-left: 20px;
}

.item_content {
  margin: 0 auto;
  max-width: calc(100% - 10px);
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  margin-top: 15px;

  .pricture_name {
    margin-top: 10px;
    margin-left: 40px;
    color: #333;
    font-size: 16pt;
    width: 80%;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
  }

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);

    border-radius: 5px;
    text-align: center;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 90%;
      max-height: 200px;
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: 95%;

      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 100px;
          line-height: 20px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
          margin-left: 50px;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}
.previewName {
  margin-left: 5px;
  color: #626262;
  font-size: 11pt;
}
.child {
  width: 60px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  text-align: center;
  line-height: 40px;
}
</style>
